const advertMPU = {
  component: "AdvertWrapper",
  props: {
    ocSlot: ["homepage", "leaderboard"],
    additionalProperties: {
      view: "football"
    }
  },
  desktopColumn: "right",
  desktopOrder: 1,
  handheldOrder: false
};

const leaderboardAd = {
  view: 'football'
};

function withAdverts(...components) {
  components.push(advertMPU);
  return {
    leaderboardAd,
    components
  };
}

const error404Layout = withAdverts({
  component: "Error404Page",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

const error500Layout = withAdverts({
  component: "Error500Page",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

export default {
  '/error/404': error404Layout,
  '/error/404/*': error404Layout,
  '/error/500': error500Layout,
  '/error/500/*': error500Layout
};



// WEBPACK FOOTER //
// ./modules/Errors/layouts.js